
import { Component, Prop, Vue } from "vue-property-decorator";
import TimeService from "@/services/TimeService";

@Component
export default class SpecialOpenDaysCard extends Vue {
  @Prop({ default: "" })
  date!: string;

  get isPast() {
    const date = new Date(this.date);
    TimeService.setDateToStartOfDay(date);
    return (
      TimeService.setDateToStartOfDay(new Date()).getTime() > date.getTime()
    );
  }

  get displayDateString() {
    const date = new Date(this.date);
    return TimeService.getDateDisplayStringWithWeekDay(date);
  }

  emitDeleteClick() {
    this.$emit("delete-open-date", this.date);
  }
}
